import { forwardRef } from 'react'
import { cn, hashIdToColor } from '../utils'
import { Color } from '../types/colors'
import { Avatar as InternalAvatar, AvatarFallback, AvatarImage } from '@bpinternal/ui-kit-next'

type Props = {
  pictureUrl?: string
  name?: string
  className?: string
  color?: Color | 'auto'
  variant?: 'solid' | 'soft'
}

const getVariantClassName = (variant: 'solid' | 'soft', color: Color) => {
  return { soft: `bg-${color}-3 text-${color}-10`, solid: `bg-${color}-9 text-white` }[variant]
}

export const Avatar = forwardRef<HTMLDivElement, Props>(
  ({ pictureUrl, name, className, color = 'auto', variant = 'soft', ...props }, ref) => {
    const firstLetter = name?.[0]?.toUpperCase() ?? '?'
    const avatarColor = color === 'auto' ? hashIdToColor(name ?? '', 'regular') : color
    const variantClassName = getVariantClassName(variant, avatarColor)

    return (
      <InternalAvatar className={className} ref={ref} {...props}>
        <AvatarImage src={pictureUrl} />
        <AvatarFallback className={cn(className, variantClassName)}>{firstLetter}</AvatarFallback>
      </InternalAvatar>
    )
  }
)

Avatar.displayName = 'Avatar'
